module.exports = "pegasus_template/assets/vr-logo.png";